'use client'

import React from 'react'
import { Media } from '@/components/Media'
import type { Media as MediaType } from '@/payload-types'

export function MediaFullBleedClient({ media }: { media: MediaType }) {
  return (
    <div className="relative h-[500px] overflow-hidden">
      <Media resource={media} className="w-full h-full" imgClassName="object-cover" fill />
    </div>
  )
}
